<template>
  <sidenav :custom_class="color" :class="[isRTL ? 'fixed-end' : 'fixed-start']" v-if="showSidenav" />
  <main class="main-content position-relative max-height-vh-100 h-100 overflow-x-hidden">
    <!-- nav -->
    <navbar :class="[isNavFixed ? navbarFixed : '', isAbsolute ? absolute : '']"
      :color="isAbsolute ? 'text-white opacity-8' : ''" :minNav="isPinned" v-if="showNavbar" />
    <router-view :key="$route.fullPath" />
    <Toast />

    <!-- <app-footer v-show="showFooter" /> -->
    <configurator :toggle="toggleConfigurator" :class="[showConfig ? 'show' : '', hideConfigButton ? 'd-none' : '']" />
  </main>
</template>
<script>
import Sidenav from "./examples/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import Toast from 'primevue/toast';

import { mapMutations, mapState } from "vuex";

export default {
  name: "App",
  components: {
    Sidenav,
    Configurator,
    Navbar,
    Toast
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"])
  },
  computed: {
    ...mapState([
      "isRTL",
      "color",
      "isAbsolute",
      "isNavFixed",
      "navbarFixed",
      "absolute",
      "showSidenav",
      "showNavbar",
      "showFooter",
      "showConfig",
      "hideConfigButton",
      "isPinned"
    ])
  },
  beforeMount() {
    this.$store.commit("setLocale", this.$store.state.locale);
    this.$store.state.isTransparent = "bg-transparent";

    const sidenav = document.getElementsByClassName("g-sidenav-show")[0];

    if (window.innerWidth > 1200) {
      sidenav.classList.add("g-sidenav-pinned");
    }
  }
};
</script>

<style>
/* Material Dashboard only offsets pinned content for a left sidebar by default. */
html[dir="rtl"] .g-sidenav-pinned .main-content {
  margin-right: 17.125rem;
  margin-left: 0;
}

html[dir="rtl"] .main-content,
html[dir="rtl"] .modal-content {
  text-align: right;
}

html[dir="rtl"] .main-content .me-1 { margin-right: 0 !important; margin-left: 0.25rem !important; }
html[dir="rtl"] .main-content .ms-1 { margin-left: 0 !important; margin-right: 0.25rem !important; }
</style>
